module.exports = __webpack_public_path__ + "4877c1ceedcd4beb06bbd3c479b3dc05.pdf";